import { render, staticRenderFns } from "./add-mating-container.vue?vue&type=template&id=718958b4&scoped=true&lang=pug"
import script from "./add-mating-container.js?vue&type=script&lang=js&external"
export * from "./add-mating-container.js?vue&type=script&lang=js&external"
import style0 from "./add-mating-container.vue?vue&type=style&index=0&id=718958b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718958b4",
  null
  
)

export default component.exports